import { Link } from 'gatsby'
import iconPurple from '../images/iconPurple.svg'
import iconWhite from '../images/iconWhite.svg'

interface NavbarProps {
  hasHero?: boolean
  onBurgerOpenClose?: (isOpen: boolean) => void
  mobileCTA?: React.ReactNode
  menuClassName?: string
}

const Navbar = ({ hasHero }: NavbarProps) => {
  return (
    <nav className="navbar is-transparent" role="navigation" aria-label="main navigation">
      <div className="container">
        <div className="navbar-brand">
          <Link className="navbar-item" to="/">
            <img width="75px" src={hasHero ? iconWhite : iconPurple} alt="C19 Testing - Home" />
          </Link>
          {/* eslint-disable jsx-a11y/anchor-is-valid */}

          {/* eslint-enable jsx-a11y/anchor-is-valid */}
        </div>
      </div>
    </nav>
  )
}

export default Navbar
